import types from '../types/types';

const initialState = {
  addressId: null,
  personalName: null,
  personalSecondName: null,
  personalLastName: null,
  personalEmail: null,
  personalPhoneType: null,
  personalPhoneNumber: null,
  shippingName: null,
  shippingSecondName: null,
  shippingLastName: null,
  shippingEmail: null,
  shippingAddressLine1: null,
  shippingAddressLine2: null,
  shippingSuburb: null,
  shippingCity: null,
  shippingState: null,
  shippingZipCode: null,
  shippingPhoneType: null,
  shippingPhoneNumber: null,
  reqFac: null,
  factData: null,
};
const shippingReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.setShippingAddress:
      return {
        ...state,
        addressId: action.addressId,
        personalName: action.personalName,
        personalSecondName: action.personalSecondName,
        personalLastName: action.personalLastName,
        personalEmail: action.personalEmail,
        personalPhoneType: action.personalPhoneType,
        personalPhoneNumber: action.personalPhoneNumber,
        shippingName: action.shippingName,
        shippingSecondName: action.shippingSecondName,
        shippingLastName: action.shippingLastName,
        shippingEmail: action.shippingEmail,
        shippingAddressLine1: action.shippingAddressLine1,
        shippingAddressLine2: action.shippingAddressLine2,
        shippingSuburb: action.shippingSuburb,
        shippingCity: action.shippingCity,
        shippingState: action.shippingState,
        shippingZipCode: action.shippingZipCode,
        shippingPhoneType: action.shippingPhoneType,
        shippingPhoneNumber: action.shippingPhoneNumber,
        reqFac: action.reqFac,
        factData: action.factData,
      };
    default:
      return state;
  }
};
export default shippingReducer;
